import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import dayjs from 'dayjs';

// Check billing document for enabled, non-expired cards
export const checkBillingCards = async (practitionerId) => {
  try {
    const billingRef = doc(db, "billing", practitionerId);
    const billingSnap = await getDoc(billingRef);

    if (!billingSnap.exists()) {
      throw new Error("NO_BILLING_DOCUMENT", { cause: "No billing document found for practitioner." });
    }

    const billingData = billingSnap.data();
    const cards = billingData.cards || [];

    // Find all enabled cards
    const enabledCards = cards.filter(card => card.enabled === true);

    if (enabledCards.length === 0) {
      throw new Error("NO_ENABLED_CARD", { cause: "No enabled card found." });
    }

    // Check card expiration for each enabled card
    const currentDate = dayjs();
    const currentMonth = currentDate.month() + 1; // dayjs months are 0-based
    const currentYear = currentDate.year();

    const validCards = enabledCards
      .filter(card => {
        const { expMonth, expYear } = card;
        // Card is expired if:
        // 1. Current year is greater than expYear, OR
        // 2. Years are equal AND current month is greater than expMonth
        return !(
          currentYear > expYear ||
          (currentYear === expYear && currentMonth > expMonth)
        );
      })
      .map(card => ({
        cardId: card.cardId,
        brand: card.brand,
        last4: card.last4,
        type: card.type || "business" // Default to "business" for legacy cards
      }));

    if (validCards.length === 0) {
      throw new Error("NO_VALID_CARD", { cause: "All enabled cards have expired." });
    }

    return validCards;
  } catch (err) {
    // Re-throw error with specific code for handling
    throw err;
  }
};